/* Board E's rolling digit: a window one line tall over a column of ten. */

/* The number's own line, exactly one window tall. An inline-block without overflow takes the
 * baseline of its line, so the digits sit on the same baseline as the text around them whatever
 * that text's line height is. (A window with `overflow: hidden` aligned on its own would put its
 * baseline at its bottom edge and drop the digit below the words next to it.) */
.number {
  display: inline-block;
  line-height: var(--sz-buddy-roll-line);
}

.window {
  display: inline-block;
  height: var(--sz-buddy-roll-line);
  overflow: hidden;
  line-height: var(--sz-buddy-roll-line);
  vertical-align: top;
}

.column {
  display: flex;
  flex-direction: column;
  transition-duration: var(--dur-buddy-roll);
  transition-property: transform;
  transition-timing-function: var(--ease-buddy-spring);
  transform: translateY(calc(var(--roll-digit) * var(--sz-buddy-roll-line) * -1));
}

.digit {
  display: block;
  height: var(--sz-buddy-roll-line);
}
